import { Button, Group, Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { EnviarRecibos } from "./EnviarRecibos";
import { EnviarRecibosDetallesProcesar } from "./EnviarRecibosDetallesProcesar/EnviarRecibosDetallesProcesar";

export const ACTProcesar: EntityClientAction = {
    name: 'ACTProcesar',
    label: 'Enviar Recibos',
    title: <Text fw={700}>Enviar Recibos</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: ['enre_brwStandard'],
    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const enviarRecibos = new EnviarRecibos(entity.API.client);
        enviarRecibos.def.columns.vc_password.value = entity.def.columns.vc_password.value as unknown as string || '';

        const procParms = {
            vc_password: enviarRecibos.def.columns.vc_password.value
        };

        let errores = '';

        if (!procParms.vc_password) {
            errores = 'Los registros seleccionados son inválidos.';
        }

        if (errores) {
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });
        }

        const abort_controller = new AbortController();
        const result = await enviarRecibos.API.executeProcess(enviarRecibos.def.procs.enre_ComprobarPassword, procParms, abort_controller.signal);

        if (result.Results[0].Status === 11) {
            errores = 'Contraseña incorrecta.';
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });
        } else {
            const enviarRecibosDetallesProcesar = new EnviarRecibosDetallesProcesar(entity.API.client);
            enviarRecibosDetallesProcesar.def.columns.c_proceso_id.value = selectedKeys![0].c_proceso_id as unknown as string || '';
            enviarRecibosDetallesProcesar.def.columns.vc_password.value = entity.def.columns.vc_password.value as unknown as string || '';

            await openEntityForm({
                modals: modal,
                formProps: {
                    entity: enviarRecibosDetallesProcesar,
                    initialFormMode: 'add',
                    getDataOnInit: true
                },
                modalFormSize: 'md',
                handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(); },
                handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(); }
            });

        }
        
        return false;
    }
}